import { takeEvery, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import get from 'lodash/get'

// @ts-ignore
import { showInfo } from 'store/entities/toastr/utils'
// @ts-ignore
import { isResponseFailed } from 'helpers/responseHelpers'
import { subscribeToProTrack } from 'store/entities/identity/actions'
import { onboarding } from 'store/entities/onBoarding/actions'

export function* handleChangeProTrack({ payload: { proTrackLevelId } }: any) {
  yield put(onboarding.changeIsLoading(true))
  // @ts-ignore
  const response = yield subscribeToProTrack.call({ proTrackLevelId })
  yield put(onboarding.changeIsLoading(false))
  if (!isResponseFailed(response)) {
    yield put(push('/dashboard'))
  } else {
    showInfo({ content: get(response, ['error', 'message'], 'An error occurred, please try again') })
  }
}

export default function* changeProTrackEvery() {
  yield takeEvery(onboarding.changeProTrack.toString(), handleChangeProTrack)
}
